import { render, staticRenderFns } from "./PlacementsModal.vue?vue&type=template&id=87005b84&scoped=true&"
import script from "./PlacementsModal.vue?vue&type=script&lang=js&"
export * from "./PlacementsModal.vue?vue&type=script&lang=js&"
import style0 from "./PlacementsModal.vue?vue&type=style&index=0&id=87005b84&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "87005b84",
  null
  
)

export default component.exports